<template>
    <div v-if="isShow" class="text-xs-center">
        <div class="entry">
            <img v-if="!growthSystemLevel" :src="map" ref="shake" />
            <img v-else-if="growthSystemUnclaimedPoints>0 && notClickClose" :src="redPacket" ref="shake" />
            <template v-else>
                <img :src="goal" />
                <p class="mb-0 blue-title">({{growthSystemTaskListCompletedLen}}/{{growthSystemTaskListLength}})</p>
            </template>
            <v-icon color="#E9E9EE" @click="close">cancel</v-icon>
        </div>
        <v-btn
            class="text-none white--text pink-button"
            text
            round
            to="/growthCenter"
        >
            {{growthSystemUnclaimedPoints>0 && notClickClose?'Receive':'Enter'}}
        </v-btn>
    </div>
</template>
<script>
import map from '@/assets/img/dashboard/growth-system/map.png'
import redPacket from '@/assets/img/dashboard/growth-system/red-packet.png'
import goal from '@/assets/img/dashboard/growth-system/goal.png'
export default {
    data:()=>({
        isShow:true,
        map,
        goal,
        redPacket,
        status:'Enter',
        timer:null,
        timer2:null,
        notClickClose:true
    }),
    mounted(){
        this.shaking();
    },
    computed:{
        growthSystemUnclaimedPoints(){
            return this.$store.state.user.growthSystemUnclaimedPoints
        },
        growthSystemLevel(){
            return this.$store.state.user.growthSystemLevel
        },
        growthSystemTaskListLength(){
            return this.$store.getters.growthSystemTaskListLength
        },
        growthSystemTaskListCompletedLen(){
            return this.$store.getters.growthSystemTaskListCompletedLen
        }
    },
    watch:{
        
    },
    methods:{
        shaking(){
            if(!this.growthSystemLevel || (this.growthSystemUnclaimedPoints>0 && this.notClickClose)){
                this.$refs.shake.className = "shake"
                this.timer = setInterval(()=>{
                    this.$refs.shake.className = "shake"
                    this.timer2 = setTimeout(()=>{
                        this.$refs.shake.classList.remove("shake")
                    },2000)
                },12000)
            }
        },
        clearTimer(){
            if(this.timer){
                clearInterval(this.timer)
                clearTimeout(this.timer2)
                this.timer = null
                this.timer2 = null
            }
        },
        close(){
            this.clearTimer()
            if(this.growthSystemUnclaimedPoints>0 && this.notClickClose){
                this.notClickClose = false
            }else{
                this.isShow = false;
            }
        }
    },
    destroyed() {
        this.clearTimer();
    }
}
</script>
<style lang="scss" scoped>
    .entry{
        position:relative;
        .v-icon{
            position: absolute;
            right: -6px;
            top: -24px;
            cursor: pointer;
        }
    }
    .shake{
        animation: shaky-slow 2s 1;
        -webkit-animation:shaky-slow 2s 1;
    }
    @keyframes shaky-slow {
            0% {            transform: translate(0px, 0px) rotate(0deg);
            }
            2% {            transform: translate(-1px, 1.5px) rotate(1.5deg);
            }
            4% {            transform: translate(1.3px, 0px) rotate(-0.5deg);
            }
            6% {            transform: translate(1.4px, 1.4px) rotate(-2deg);
            }
            8% {            transform: translate(-1.3px, -1px) rotate(-1.5deg);
            }
            10% {            transform: translate(1.4px, 0px) rotate(-2deg);
            }
            12% {            transform: translate(-1.3px, -1px) rotate(-2deg);
            }
            14% {            transform: translate(1.5px, 1.3px) rotate(1.5deg);
            }
            16% {            transform: translate(1.5px, -1.5px) rotate(-1.5deg);
            }
            18% {            transform: translate(1.3px, -1.3px) rotate(-2deg);
            }
            20% {            transform: translate(1px, 1px) rotate(-0.5deg);
            }
            22% {            transform: translate(1.3px, 1.5px) rotate(-2deg);
            }
            24% {            transform: translate(-1.4px, -1px) rotate(2deg);
            }
            26% {            transform: translate(1.3px, -1.3px) rotate(0.5deg);
            }
            28% {            transform: translate(1.6px, -1.6px) rotate(-1.5deg);
            }
            30% {            transform: translate(-1.3px, -1.3px) rotate(-1.5deg);
            }
            32% {            transform: translate(-1px, 0px) rotate(2deg);
            }
            34% {            transform: translate(1.3px, 1.3px) rotate(-0.5deg);
            }
            36% {            transform: translate(1.3px, 1.6px) rotate(1.5deg);
            }
            38% {            transform: translate(1.3px, -1.6px) rotate(1.5deg);
            }
            40% {            transform: translate(-1.4px, -1px) rotate(-0.5deg);
            }
            42% {            transform: translate(-1.4px, 1.3px) rotate(-0.5deg);
            }
            44% {            transform: translate(-1.6px, 1.4px) rotate(0.5deg);
            }
            46% {            transform: translate(-2.1px, -1.3px) rotate(-0.5deg);
            }
            48% {            transform: translate(1px, 1.6px) rotate(1.5deg);
            }
            50% {            transform: translate(1.6px, 1.6px) rotate(1.5deg);
            }
            52% {            transform: translate(-1.4px, 1.6px) rotate(0.5deg);
            }
            54% {            transform: translate(1.6px, -1px) rotate(-2deg);
            }
            56% {            transform: translate(1.3px, -1.6px) rotate(-2deg);
            }
            58% {            transform: translate(-1.3px, -1.6px) rotate(0.5deg);
            }
            60% {            transform: translate(1.3px, 1.6px) rotate(-0.5deg);
            }
            62% {            transform: translate(0px, 0px) rotate(-1.5deg);
            }
            64% {            transform: translate(-1.6px, -1.6px) rotate(-2deg);
            }
            66% {            transform: translate(1.6px, -1.6px) rotate(0.5deg);
            }
            68% {            transform: translate(0px, -1.6px) rotate(-2deg);
            }
            70% {            transform: translate(-1.6px, 1px) rotate(1.5deg);
            }
            72% {            transform: translate(-1.6px, 1.6px) rotate(2deg);
            }
            74% {            transform: translate(1.3px, -1.6px) rotate(-0.5deg);
            }
            76% {            transform: translate(1.4px, 1px) rotate(-0.5deg);
            }
            78% {            transform: translate(-1px, 1.4px) rotate(2deg);
            }
            80% {            transform: translate(1.4px, 1.6px) rotate(2deg);
            }
            82% {            transform: translate(-1.6px, -1.6px) rotate(-0.5deg);
            }
            84% {            transform: translate(-1.4px, 1.4px) rotate(-2deg);
            }
            86% {            transform: translate(1px, 1.4px) rotate(-2deg);
            }
            88% {            transform: translate(-1.4px, 1.4px) rotate(-1.5deg);
            }
            90% {            transform: translate(-1.6px, -1.6px) rotate(-2deg);
            }
            92% {            transform: translate(-1.4px, 1.6px) rotate(2deg);
            }
            94% {            transform: translate(-1.6px, -1.6px) rotate(-2deg);
            }
            96% {            transform: translate(-1.4px, 1.3px) rotate(-2deg);
            }
            98% {            transform: translate(1.3px, 1px) rotate(-0.5deg);
            }
    }
</style>